import Router from 'vue-router';

export default function (Vue) {
	Vue.use(Router);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/not-found',
				name: 'page-error',
				component: () => import('@/pages/page-error'),
				meta: {
					title: 'Error',
				},
				props: true,
			},
			{
				path: '/',
				name: 'page-home',
				component: () => import('@/pages/page-home'),
				meta: {
					title: 'Home',
				},
				props: true,
			},
			{
				path: '/productos',
				name: 'page-product',
				component: () => import('@/pages/page-products'),
				meta: {
					title: 'Products',
				},
				props: true,
			},
			{
				path: '/productos/detalle/:id',
				name: 'page-detail',
				component: () => import('@/pages/page-detail'),
				meta: {
					title: 'Detail',
				},
				props: true,
			},
			{
				path: '/admin',
				name: 'page-admin',
				component: () => import('@/pages/page-admin'),
				props: true,
			},
			{
				path: '/admin-company',
				name: 'page-admin-company',
				component: () => import('@/pages/page-admin-company'),
				props: true,
			},
			{
				path: '/products-admin',
				name: 'products-admin',
				redirect: '/products-admin/list',
				component: () => import('@/pages/page-admin-products'),
				props: true,
				children: [
					{
						path: 'list',
						name: 'products-list',
						component: () => import('@/pages/page-products-list'),
						props: true,
					},
					{
						path: 'new',
						name: 'products-new',
						component: () => import('@/pages/page-product-new'),
					},
					{
						path: 'edit/:id',
						name: 'products-edit',
						component: () => import('@/pages/page-product-new'),
						props: true,
					},
				],
			},
		],
		linkActiveClass: 'active',
		scrollBehavior() {
			return { x: 0, y: 0 };
		},
	});
	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js